<template lang="html">
  <div text-center d-flex align-center>

    <!-- Dialog de confirmação para exclusão de uma instituição -->
    <c-confirm-dialog v-model="dialogConfirmaExclusao" @yes="excluirInstituicao()" titulo="Deseja realmente excluir a instituição?">
    </c-confirm-dialog>

    <!-- Tabela com as instituições -->
    <v-data-table
      :headers="headers"
      :items="listaInstituicoes"
      :search="search"
      :no-data-text="'Nenhuma instituição cadastrada.'"
      must-sort
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :items-per-page="itemsPerPage"
      :footer-props="{itemsPerPageText: 'Linhas por página', itemsPerPageOptions: opcoesPaginacao}"
    >
      <template v-slot:item.opcoes="props">

        <!-- Editar instituição -->
        <c-tooltip-btn
          icon="edit"
          color="primary"
          tooltip="Editar instituição"
          @click="toEditarInstituicao(props.item.id)"
          v-if="administradorPRPPG || projetoPesquisa.coordenador"
        ></c-tooltip-btn>

        <!-- Excluir instituição -->
        <!-- A Ufes (idInstituicao = 1) não pode ser excluída) -->
        <c-tooltip-btn
          icon="delete"
          color="primary"
          tooltip="Excluir instituição"
          :disabled="props.item.idInstituicao === 1"
          disabled-tooltip='A Ufes não pode ser excluída'
          @click="toExcluirInstituicao(props.item.id)"
          v-if="administradorPRPPG || projetoPesquisa.coordenador"
        ></c-tooltip-btn>

      </template>

      <!-- Formata a sigla -->
      <template v-slot:item.sigla="props">{{ props.item.sigla === null || props.item.sigla === '' ? '-' : props.item.sigla }}</template>

      <!-- Número total de instituições -->
      <template slot="footer.page-text" slot-scope="{ pageStart, pageStop }">
        Mostrando {{ pageStart }} a {{ pageStop }} de {{ listaInstituicoes.length }} {{ listaInstituicoes.length > 1 ? 'instituições' : 'instituição' }}
      </template>

    </v-data-table>

    <br><br>

    <v-card-actions>

      <!-- Botão "Voltar" -->
      <v-btn color="primary" @click="toVoltar()">Voltar</v-btn>

      <v-spacer></v-spacer>

      <!-- Botão "Adicionar Instituição" -->
      <v-btn color="primary" @click="toPesquisarInstituicao()" v-if="administradorPRPPG || projetoPesquisa.coordenador">Adicionar Instituição</v-btn>

      <!-- Botão "Avançar" -->
      <v-btn color="primary" @click="toAvancar()">Avançar</v-btn>

    </v-card-actions>
    

  </div>
</template>

<script>
import projetos from '@/utils/projetos'
import ConfirmDialog from '@/components/c-confirm-dialog'
import BasicToolbar from '@/components/toolbars/basic-toolbar'
import TootipButton from '@/components/c-tooltip-btn'
import { mapGetters, mapActions } from 'vuex'

export default {
  props: ['idProjetoPesquisa', 'projetoPesquisa'],
  data: () => ({
    dialogConfirmaExclusao: false,
    idInstituicaoProjetoPesquisaExclusao: '',
    listaInstituicoes: [],
    search: null,
    sortDesc: false,
    itemsPerPage: 25,
    opcoesPaginacao: [ 10, 25, 50, {text: 'Todas', value: -1} ],
    headers: [
      { text: 'Nome', align: 'left', value: 'nome' },
      { text: 'Sigla', align: 'left', value: 'sigla' },
      { text: 'Tipo', align: 'left', value: 'tipoInstituicao.descricao' },
      { text: 'Opções', align: 'left', value: 'opcoes' }
    ]
  }),
  computed: {
    ...mapGetters('auth', ['administrador', 'administradorPRPPG'])
  },
  methods: {
    ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),

    // Carrega as instituições do projeto de pesquisa.
    carregaInstituicoesProjetoPesquisa: function () {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando instituições...' })
      projetos.getInstituicoesProjetoPesquisa(this.idProjetoPesquisa)
      .then(response => {
        this.listaInstituicoes = response.data.slice()
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando instituições...' })
      })
    },

    // Edita a instituição.
    toEditarInstituicao: function (idInstituicaoProjetoPesquisa) {
      this.$router.push({ name: 'EditarProjetoPesquisaInstituicao', params: {idProjetoPesquisa: this.idProjetoPesquisa, idInstituicaoProjetoPesquisa: idInstituicaoProjetoPesquisa} })
    },

    // Voltar para a aba anterior.
    toVoltar: function () {
      this.$router.push({ name: 'ProjetoPesquisaDetalhamento', params: {idProjetoPesquisa: this.idProjetoPesquisa} })
    },

    // Avançar para a próxima aba.
    toAvancar: function () {
      this.$router.push({ name: 'ProjetoPesquisaEquipe', params: {idProjetoPesquisa: this.idProjetoPesquisa} })
    },

    // Pesquisa por instituições.
    toPesquisarInstituicao: function () {
      this.$router.push({ name: 'ProjetoPesquisaPesquisarInstituicao', params: {idProjetoPesquisa: this.idProjetoPesquisa} })
    },

    // Exclui uma instituição (abre dialog de confirmação).
    toExcluirInstituicao: function (idInstituicaoProjetoPesquisa) {
      this.idInstituicaoProjetoPesquisaExclusao = idInstituicaoProjetoPesquisa
      this.dialogConfirmaExclusao = true
    },

    // Exclui uma instituição (chama endpoint para exclusão).
    excluirInstituicao: function () {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo instituição...' })
      projetos.deleteInstituicaoProjetoPesquisa(this.idProjetoPesquisa, this.idInstituicaoProjetoPesquisaExclusao)
      .then(response => {
        this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
        this.carregaInstituicoesProjetoPesquisa()
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
        this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo instituição...' })
      })
    }
  },
  mounted () {
    this.carregaInstituicoesProjetoPesquisa()
  },
  components: {
    'basic-toolbar': BasicToolbar,
    'c-tooltip-btn': TootipButton,
    'c-confirm-dialog': ConfirmDialog
  }
}
</script>

<style lang="css" slot-scoped>
</style>



// WEBPACK FOOTER //
// instituicoes.vue?6f31b2cc